module.exports = __webpack_public_path__ + "img/72.d2d44700.png";